var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediumNegative(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4609 7.39231C8.4609 9.74901 6.56684 11.6595 4.23052 11.6595C1.89421 11.6595 0 9.74858 0 7.39231C0 5.03605 1.89406 3.125 4.23052 3.125C6.56698 3.125 8.4609 5.03561 8.4609 7.39231Z",
    fill: "#CEBFBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1017 7.39235C13.1017 9.61067 12.1547 11.4097 10.9865 11.4097C9.81825 11.4097 8.87122 9.61067 8.87122 7.39235C8.87122 5.17402 9.8181 3.375 10.9863 3.375C12.1546 3.375 13.1016 5.17345 13.1016 7.39235",
    fill: "#CEBFBF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.39236C15 9.37944 14.667 10.9913 14.2561 10.9913C13.8451 10.9913 13.5123 9.37987 13.5123 7.39236C13.5123 5.40486 13.8453 3.79346 14.2561 3.79346C14.6668 3.79346 15 5.40471 15 7.39236Z",
    fill: "#CEBFBF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumNegative);
export default __webpack_public_path__ + "static/media/Medium - Negative.8af6a7e61a13ead02db4c390f98966b7.svg";
export { ForwardRef as ReactComponent };